import "./EmailAccountsStatusOverview.scss"

import { CELL_VARIANT, STATUS_COLOR, SvgIcon, TableCell } from "@skylead/component-library"
import React from "react"

import { truncateString } from "../../../utils/global-utils"
import { useGlobalTranslation, useTooltip } from "../../../utils/hook"
import { hasPermission } from "../../../utils/team-management/team-management-utils"
import LangText from "../LangText"

const EmailAccountsStatusOverview = ({ emailAccounts = [] }) => {
  const { tt } = useGlobalTranslation()
  const [tooltip, setTooltip, closeTooltip] = useTooltip(10, 0)

  const getEmailStatus = status => {
    if (status === "ACTIVE") {
      return (
        <TableCell
          cellType={CELL_VARIANT.STATUS}
          text={tt("connected")}
          statusIcon="check-16"
          statusColor={STATUS_COLOR.GREEN}
          hasPermission={hasPermission}
          tt={tt}
        />
      )
    }
    if (status === "INACTIVE") {
      return (
        <TableCell
          cellType={CELL_VARIANT.STATUS}
          text={tt("disconnected")}
          statusIcon="circle-half-diagonal-16"
          statusColor={STATUS_COLOR.RED}
          hasPermission={hasPermission}
          tt={tt}
        />
      )
    }
  }

  return (
    <div className="email-status-overview">
      {tooltip}
      <div className="column-names">
        <span>
          <LangText langKey="email" />
        </span>
        <span>
          <LangText langKey="status" />
        </span>
      </div>
      <div className="divider" />
      <div className="email-list">
        {emailAccounts?.slice(0, 6).map(emailAccount => {
          return (
            <div className="row">
              <div className="d-flex">
                <SvgIcon icon={emailAccount.type} className="top-section-email-icon" />
                <span
                  onMouseEnter={e => {
                    if (emailAccount.email.length > 50) {
                      setTooltip({ event: e, text: emailAccount.email, topPos: 45 })
                    }
                  }}
                  onMouseLeave={closeTooltip}
                >
                  {truncateString(emailAccount.email, 50)}
                </span>
              </div>
              <div>{getEmailStatus(emailAccount.status)}</div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

// EmailAccountsStatusOverview.propTypes = {
//   emailAccounts: PropTypes.arrayOf(
//     PropTypes.shape({
//       email: PropTypes.string,
//       type: PropTypes.string,
//       status: PropTypes.oneOf(["ACTIVE", "INACTIVE"]),
//     }),
//   ),
// }

export default EmailAccountsStatusOverview
